<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TIT_HAND_COND_LIST') }}</h4>
      </div>
      <sui-grid
        ref="grid0"
        :columns="gridColumns0"
        :dataset="'dsHandCond'"
        :showDisplayCountControl="false"
        :initial-pagesize="3"
        :pagesizeoptions="[3]"
        :multiselect="true"
      >
        <div class="comp_spacing" />
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowDelete('dsHandCond')"
          >
            {{ $t('MSG_BTN_ROW_DEL') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowAdd('dsHandCond')"
          >
            {{ $t('MSG_BTN_ROW_ADD') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickCancel('dsHandCond')"
          >
            {{ $t('MSG_BTN_CANCEL') }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TIT_AUTO_COND_LIST') }}</h4>
      </div>
      <sui-grid
        ref="grid1"
        :columns="gridColumns1"
        :dataset="'dsAutoCond'"
        :showDisplayCountControl="false"
        :initial-pagesize="3"
        :pagesizeoptions="[3]"
        :multiselect="true"
      >
        <div class="comp_spacing" />
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowDelete('dsAutoCond')"
          >
            {{ $t('MSG_BTN_ROW_DEL') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowAdd('dsAutoCond')"
          >
            {{ $t('MSG_BTN_ROW_ADD') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowCancel('dsAutoCond')"
          >
            {{ $t('MSG_BTN_CANCEL') }}
          </sui-button>
        </div>
      </sui-grid>
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickApply"
        >
          {{ $t('MSG_BTN_APPLY') }}
        </sui-button>
      </div>
    </sui-page-footer>
    <sui-popup
      v-model="isPopupShow"
      :title="$t('MSG_TIT_SQL_EDIT')"
    >
      <p01
        :pageId="$options.name"
        :ruleUid="pageInitialData.ruleUid"
        :ruleName="pageInitialData.ruleName"
        :ruleConditionInfo="ruleConditionInfo"
        @popupClose="popupClose"
        @paramReturn="paramReturn"
      />
    </sui-popup>
  </sui-page>
</template>
<script>

import BasePage from '~cm/components/BasePage';
import p01 from './components/PGE_CMR_00008_P01';

export default {
  name: 'PGE_CMR_00008',
  components: {
    p01,
  },
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default() {
        return null;
      },
    },
    pageInitialData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isPopupShow: false,
      inBoundDVOList: [],
      commonOptionList: {
        COD_RULE_CPRS_COND: [],
      },
      ruleConditionInfo: {},
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_IN_DVO'),
        datafield: 'dvoName',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          const componentInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.inBoundDVOList,
            },
            this.dsHandCond, this.$refs.grid0);

          componentInstance.getComponentInstance().$on('select', event => {
            const rowIndex = componentInstance.getDatasetIndex();
            this.dvoSelectChange(rowIndex, event, 'dsHandCond');
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_COND_VAL'),
        datafield: 'ruleHandOperatedConditionContent',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
            {
              trim: true,
              checkDisabledFunction: this.checkDisabledFunction,
            },
            this.dsHandCond, this.$refs.grid0);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
      localdata1: [],
      gridColumns1: [{
        text: this.$t('MSG_TXT_IN_DVO'),
        datafield: 'dvoName',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          const componentInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.inBoundDVOList,
            },
            this.dsAutoCond, this.$refs.grid1);

          componentInstance.getComponentInstance().$on('select', event => {
            const rowIndex = componentInstance.getDatasetIndex();
            this.dvoSelectChange(rowIndex, event, 'dsAutoCond');
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_COND_BASE_VAL'),
        datafield: 'ruleConditionStandardItemName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
            {
              trim: true,
              checkDisabledFunction: this.checkDisabledFunction,
            },
            this.dsAutoCond, this.$refs.grid1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_COND'),
        datafield: 'ruleComparisonConditionCode',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.commonOptionList.COD_RULE_CPRS_COND,
            },
            this.dsAutoCond, this.$refs.grid1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_CPRS_VAL'),
        datafield: 'ruleComparisonValue',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextFieldWithButton(row, column, value, htmlElement, {
            textFieldProps: {
              readonly: false,
              checkDisabledFunction: this.ruleComparisonValueDisabled,
            },
            buttonProps: {
              name: this.$t('MSG_BTN_SQL_EDIT'),
              disabled: false,
            },
            handler: this.onClickSqlEdit,
          }, this.dsAutoCond, this.$refs.grid1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dsHandCond',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'ruleConditionUid', map: 'ruleConditionUid' },
      { type: 'string', name: 'ruleUid', map: 'ruleUid' },
      { type: 'string', name: 'ruleConditionTypeCode', map: 'ruleConditionTypeCode' },
      { type: 'string', name: 'dvoName', map: 'dvoName' },
      { type: 'string', name: 'ruleConditionStandardItemName', map: 'ruleConditionStandardItemName' },
      { type: 'string', name: 'ruleComparisonConditionCode', map: 'ruleComparisonConditionCode' },
      { type: 'string', name: 'ruleComparisonValueTypeCode', map: 'ruleComparisonValueTypeCode' },
      { type: 'string', name: 'ruleComparisonValue', map: 'ruleComparisonValue' },
      { type: 'string', name: 'ruleHandOperatedConditionContent', map: 'ruleHandOperatedConditionContent' },
      { type: 'string', name: 'sqlTableName', map: 'sqlTableName' },
      { type: 'string', name: 'sqlBasicValue', map: 'sqlBasicValue' },
      { type: 'string', name: 'sqlColumnName', map: 'sqlColumnName' },
      { type: 'string', name: 'sqlColumnTypeCode', map: 'sqlColumnTypeCode' },
      { type: 'string', name: 'sqlConditionContent', map: 'sqlConditionContent' }],
  }, {
    id: 'dsAutoCond',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { type: 'string', name: 'ruleConditionUid', map: 'ruleConditionUid' },
      { type: 'string', name: 'ruleUid', map: 'ruleUid' },
      { type: 'string', name: 'ruleConditionTypeCode', map: 'ruleConditionTypeCode' },
      { type: 'string', name: 'dvoName', map: 'dvoName' },
      { type: 'string', name: 'ruleConditionStandardItemName', map: 'ruleConditionStandardItemName' },
      { type: 'string', name: 'ruleComparisonConditionCode', map: 'ruleComparisonConditionCode' },
      { type: 'string', name: 'ruleComparisonValueTypeCode', map: 'ruleComparisonValueTypeCode' },
      { type: 'string', name: 'ruleComparisonValue', map: 'ruleComparisonValue' },
      { type: 'string', name: 'ruleHandOperatedConditionContent', map: 'ruleHandOperatedConditionContent' },
      { type: 'string', name: 'sqlTableName', map: 'sqlTableName' },
      { type: 'string', name: 'sqlBasicValue', map: 'sqlBasicValue' },
      { type: 'string', name: 'sqlColumnName', map: 'sqlColumnName' },
      { type: 'string', name: 'sqlColumnTypeCode', map: 'sqlColumnTypeCode' },
      { type: 'string', name: 'sqlConditionContent', map: 'sqlConditionContent' },
      { type: 'string', name: 'ruleConditionBindInfo', map: 'ruleConditionBindInfo' },
    ],
  }],
  mounted() {
    this.$nextTick(() => {
      this.setInboundDVOList();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 조건 목록 조회
     */
    setConditionList() {
      if (utils.isEmpty(this.pageInitialData.ruleConditionInfo)
        || (utils.size(this.pageInitialData.ruleConditionInfo.autoConditionList) < 1
         && utils.size(this.pageInitialData.ruleConditionInfo.handConditionList) < 1)) {
        http.request(this.$options.name, 'DTS_CMR_00044', {
          path: {
            'rule-uid': this.pageInitialData.ruleUid,
          },
        }).then(res => {
          this.dsHandCond.setRawData(this.ruleConditionDefaultValueAdd(res.data.ruleConditionManualList)); // 수동 조건 목록
          this.dsAutoCond.setRawData(this.ruleConditionDefaultValueAdd(res.data.ruleConditionAutoList)); // 자동 조건 목록
        });
      } else {
        this.dsHandCond.setRawData(this.pageInitialData.ruleConditionInfo.handConditionList); // 수동 조건 목록
        this.dsAutoCond.setRawData(this.pageInitialData.ruleConditionInfo.autoConditionList); // 자동 조건 목록
      }
    },
    /**
     * row마다 saveRuleConditionBindList null 값 선언
     * service에서 로직 수행 시 saveRuleConditionBindList 선언이 안되어있으면 에러 발생.
     */
    ruleConditionDefaultValueAdd(list) {
      const ruleConditionList = utils.clone(list);
      utils.forEach(ruleConditionList, (value, key) => {
        ruleConditionList[key].ruleConditionBindInfo = { saveRuleConditionBindList: [] };
      });
      return ruleConditionList;
    },
    /**
     * 자동조건 '조건' 항목 optionList 조회
     */
    commCodeSelect() {
      http.mergeCodeList(this.$options.name, ['COD_RULE_CPRS_COND'], this.commonOptionList).then(() => {
        this.setConditionList();
      });
    },
    /**
     * InboundDVO optionList 조회
     */
    setInboundDVOList() {
      http.request(this.$options.name, 'DTS_CMR_00010', {
        path: {
          'data-service-id': this.pageInitialData.dataServiceId,
        },
      }).then(res => {
        const inBoundDVOList = [];
        this.inBoundDVOList = [];

        utils.forEach(res.data, obj => {
          const option = {
            key: obj.code,
            label: obj.displayName,
          };
          inBoundDVOList.push(option);
        });
        this.inBoundDVOList = inBoundDVOList;

        // (공통) 조건 코드 optionList조회
        this.commCodeSelect();
      });
    },
    dvoSelectChange(rowIndex, event, datasetId) {
      const columnName = utils.isEqual(datasetId, 'dsHandCond')
        ? 'ruleHandOperatedConditionContent'
        : 'ruleConditionStandardItemName';
      if (utils.startsWith(event, 'entity')) {
        this[datasetId].setData(rowIndex, columnName, event);
      } else if (utils.startsWith(event, 'ResponseSize')) {
        this[datasetId].setData(rowIndex, columnName, 'size');
      } else {
        this[datasetId].setData(rowIndex, columnName, '');
      }
    },
    paramMappingValueDisabled(rowIndex, datasetId) {
      const { dvoName } = this[datasetId].data[rowIndex];
      if (utils.isEmpty(dvoName)) return false;
      if (utils.startsWith(dvoName, 'entity') || utils.startsWith(dvoName, 'ResponseSize')) {
        return true;
      }
      return false;
    },
    // ruleComparisonValueDisabled(rowIndex) {
    //   const { dvoName } = this.dsAutoCond.data[rowIndex];
    //   if (utils.isEmpty(dvoName)) return false;
    //   if (utils.startsWith(dvoName, 'entity') || utils.startsWith(dvoName, 'ResponseSize')) {
    //     return true;
    //   }
    //   return false;
    // },
    /**
     * grid button event
     */
    onClickRowCancel(datasetId) {
      this[datasetId].setRawData(this[datasetId].originalData);
    },
    onClickRowDelete(datasetId) {
      const selectedIndexes = this[datasetId].getSelectedIndexes();
      this[datasetId].deleteRows(selectedIndexes);
    },
    onClickRowAdd(datasetId) {
      const ruleConditionTypeCode = utils.isEqual(datasetId, 'dsAutoCond') ? 'AT' : 'MA'; //
      const ruleComparisonValueTypeCode = utils.isEqual(datasetId, 'dsAutoCond') ? 'TX' : '';

      const defaultRow = [{
        ruleConditionUid: '',
        ruleUid: '',
        ruleConditionTypeCode,
        dvoName: '',
        ruleConditionStandardItemName: '',
        ruleComparisonConditionCode: '',
        ruleComparisonValueTypeCode,
        ruleComparisonValue: '',
        ruleHandOperatedConditionContent: '',
        sqlTableName: '',
        sqlColumnName: '',
        sqlBasicValue: '',
        sqlColumnTypeCode: '',
        sqlConditionContent: '',
        ruleConditionBindInfo: { saveRuleConditionBindList: [] },
      }];
      this[datasetId].addRows(defaultRow);
    },
    /**
     * button event
     */
    onClickCancel() {
      this.closePagePopup('');
    },
    onClickApply() {
      if (!this.handValidationCheck()) return false;
      if (!this.autoValidationCheck()) return false;
      // utils.concat(this.dsHandCond.data, this.dsAutoCond.data)
      const conditionInfo = {
        handConditionList: utils.clone(this.dsHandCond.data),
        autoConditionList: utils.clone(this.dsAutoCond.data),
      };
      this.closePagePopup(conditionInfo);
      return null;
    },
    /**
     * sql 편집 팝업
     */
    onClickSqlEdit(event, dataRow) {
      this.isPopupShow = true;
      this.ruleConditionInfo = dataRow;
    },
    popupClose() {
      this.isPopupShow = false;
    },
    paramReturn(conditionInfo, conditionBindInfo) {
      const index = utils.findIndex(this.dsAutoCond.data,
        o => utils.isEqual(o['dataset-row-id'], this.ruleConditionInfo['dataset-row-id']));
      const dsAutoData = utils.clone(this.dsAutoCond.data);

      utils.forEach(conditionInfo, (value, key) => {
        dsAutoData[index][key] = value;
      });

      dsAutoData[index].ruleConditionBindInfo = { saveRuleConditionBindList: conditionBindInfo };
      this.dsAutoCond.setRawData(dsAutoData);
    },
    /**
     * 입력 체크
     */
    handValidationCheck() {
      let flag = true;
      utils.forEach(this.dsHandCond.data, (obj, row) => {
        if (utils.isEmpty(obj.dvoName)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_IN_DVO')),
          null,
          () => {
            this.gridSetFocus(row, 'dvoName', 'grid0');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.ruleHandOperatedConditionContent)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_COND_VAL')),
          null,
          () => {
            this.gridSetFocus(row, 'ruleHandOperatedConditionContent', 'grid0');
          });
          flag = false;
          return false;
        }
        return null;
      });
      return flag;
    },
    autoValidationCheck() {
      let flag = true;
      utils.forEach(this.dsAutoCond.data, (obj, row) => {
        if (utils.isEmpty(obj.dvoName)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_IN_DVO')),
          null,
          () => {
            this.gridSetFocus(row, 'dvoName', 'grid1');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.ruleConditionStandardItemName)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_COND_BASE_VAL')),
          null,
          () => {
            this.gridSetFocus(row, 'ruleConditionStandardItemName', 'grid1');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.ruleComparisonConditionCode)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_COND')),
          null,
          () => {
            this.gridSetFocus(row, 'ruleComparisonConditionCode', 'grid1');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.ruleComparisonValue)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_CPRS_VAL')),
          null,
          () => {
            this.gridSetFocus(row, 'ruleComparisonValue', 'grid1');
          });
          flag = false;
          return false;
        }
        return null;
      });
      return flag;
    },
    gridSetFocus(rowIndex, datafield, grid) {
      this.$refs[grid].$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs[grid].getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
    /**
     * grid disabled Function
     */
    checkDisabledFunction(rowData) {
      const { dvoName } = rowData;
      if (utils.isEmpty(dvoName)) {
        return false;
      } if (utils.startsWith(dvoName, 'entity') || utils.startsWith(dvoName, 'ResponseSize')) {
        return true;
      }
      return false;
    },
    /**
     * grid SQL TextField disabled
     */
    ruleComparisonValueDisabled(rowData) {
      const { ruleComparisonValueTypeCode } = rowData;
      if (utils.isEqual(ruleComparisonValueTypeCode, 'SQ')) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
